import { getDom, stopPropagation, resetRange } from './utils/function';

export function initInput(input) {
    const { inputElement, defaultContent } = input;
    this.input_el = getDom(inputElement);
    if (!this.input_el) return;

    // 处理元素属性
    this.input_el.setAttribute('contenteditable', true);
    this.input_el.setAttribute('placeholder', input.placeholder || '');
    this.input_el.classList.add('rhemoji-input-box');
    this.input_el.style.outline = 'none';

    // 绑定事件
    // this.input_el.addEventListener('click', resetRange);

    // const _that = this;
    // document.addEventListener('keyup', e => {
    //     if (_that.input_el.id === document.activeElement.id) {
    //         resetRange();
    //     }
    // });

    // 处理默认内容
    if (defaultContent) {
        const content = this.transCode2Img(defaultContent);

        this.input_el.innerHTML = content;
    }
}

function handlelistPosition(el, node, alignment = ['left', 'top']) {
    node.style.position = 'absolute';

    const [tra, pro] = alignment;

    if (tra === 'left') {
        node.style.left = 0;
    } else {
        node.style.right = 0;
    }

    if (pro === 'top') {
        node.style.top = el.offsetHeight + 12 + 'px';
    } else {
        node.style.bottom = el.offsetHeight + 12 + 'px';
    }
}

function handleTrianglePosition(el, node, alignment = ['left', 'top']) {
    node.style.position = 'absolute';

    const [tra, pro] = alignment;
    const trNodeWidth = 8;
    if (tra === 'left') {
        node.style.left = el.offsetWidth / 2 - trNodeWidth + 'px';
    } else {
        node.style.right = el.offsetWidth / 2 - trNodeWidth + 'px';
    }

    if (pro === 'top') {
        node.style.top = -16 + 'px';
    } else {
        node.style.filter = "progid:DXImageTransform.Microsoft.Matrix(M11=-0.707,M12=-0.707,M21=0.707,M22=-0.707,SizingMethod='auto expand')";

        node.style.transform = 'rotate(180deg)';
        node.style.bottom = -16 + 'px';
    }
}

export function initList(list) {
    const { iconElement, alignment } = list;
    this.icon_el = getDom(iconElement);
    if (!this.icon_el) return;
    // 处理icon
    if (!this.icon_el.style.position || this.icon_el.style.position == '') {
        this.icon_el.style.position = 'relative';
    }

    // 处理list
    const parentNode = document.createElement('div');
    parentNode.className = this.list_class + '-wrap';
    const node = document.createElement('div');
    node.className = this.list_class;
    parentNode.style.position = 'absolute';
    parentNode.style.width = list.width ? list.width + 'px' : '325px';
    parentNode.style.height = list.height ? list.height + 'px' : '170px';
    parentNode.style.display = list.defaultShow ? '' : 'none';
    // 处理位置
    handlelistPosition(this.icon_el, parentNode, alignment);

    parentNode.click = function(e) {
        stopPropagation(e);
    };

    node.onclick = function(e) {
        stopPropagation(e);
    };

    this.emojis.forEach(i => {
        const imgWrap = document.createElement('div');
        const para = document.createElement('img');
        para.setAttribute('class', 'emoji');
        para.setAttribute('src', i.src);
        para.onclick = e => this.handleImgClick(e, i, list, parentNode);
        imgWrap.appendChild(para);
        node.appendChild(imgWrap);
    });

    const triangleNode = document.createElement('div');
    triangleNode.className = 'triangle-icon';

    triangleNode.onclick = function(e) {
        stopPropagation(e);
    };

    handleTrianglePosition(this.icon_el, triangleNode, alignment);

    parentNode.appendChild(triangleNode);
    parentNode.appendChild(node);
    this.icon_el.appendChild(parentNode);

    // 处理事件
    this.icon_el.addEventListener('click', () => {
        if (parentNode.style.display === 'none') {
            parentNode.style.display = '';
        } else {
            parentNode.style.display = 'none';
        }
        this.toggleChange && this.toggleChange();
    });

    document.body.addEventListener('click', e => {
        // 表示触发的就是复层节点
        if (e.target.id && e.target.id === this.icon_el.id) return;
        if (e.target.className && e.target.className.indexOf(parentNode.className) >= 0) return;
        const element = e.target.parentElement;

        if (element.id && element.id === this.icon_el.id) return;
        if (element.className && element.className.indexOf(parentNode.className) >= 0) return;
        parentNode.style.display = 'none';
    });
}

export function handleImgClick(e, i, list, parentNode) {
    stopPropagation(e);
    this.input_el.focus();
    const selection = window.getSelection();

    const insertHtml = `<img draggable="false" class="emo" src="${i.src}" data-type="${i.code}">`;

    if (this.lastEditRange) {
        selection.removeAllRanges();
        selection.addRange(this.lastEditRange);
    }

    document.execCommand('insertHTML', false, insertHtml);

    if (list.autoClose) {
        parentNode.style.display = 'none';
    }
}
